// Keep every admin screen on the same salon context.
export const DEFAULT_SALON_ID = '68c806bf374b8c596edb208c';

export function getSelectedSalonId() {
  // This installation has one salon only. Do not allow a stale salon id in
  // localStorage to make individual screens read from a different database.
  try { localStorage.setItem('@selectedSalon', DEFAULT_SALON_ID); } catch {}
  return DEFAULT_SALON_ID;
}
